import axios from 'axios'
import { useUserStore } from '@/stores/user'

const apiBase = 'https://ncht.bz'

function http() {
  const userStore = useUserStore()
  return axios.create({
    baseURL: `${apiBase}/api/utm`,
    headers: {
      Authorization: `Bearer ${userStore.token}`,
    },
  })
}

export const utmApi = {
  data: () => http().get('/data'),
  campaigns: () => http().get('/campaign'),
  content: () => http().get('/content'),
  add: (body) => http().post('/add', body),
  deleteContentLegacy: (id) => http().post('/delete-content', { id }),
  addRegistry: (body) => http().post('/add_registry', body),

  createOrigin: (body) => http().post('/origins', body),
  updateOrigin: (id, body) => http().put(`/origins/${id}`, body),
  deleteOrigin: (id) => http().delete(`/origins/${id}`),

  createCampaign: (body) => http().post('/campaign', body),
  updateCampaign: (id, body) => http().put(`/campaign/${id}`, body),
  deleteCampaign: (id) => http().delete(`/campaign/${id}`),

  createContent: (body) => http().post('/content', body),
  updateContent: (id, body) => http().put(`/content/${id}`, body),
  deleteContent: (id) => http().delete(`/content/${id}`),

  telegram: (body) => axios.post('https://forms.ncht.bz/webhook/telegram/create-link', body),
}
